export const WHATS_NEXT_APIS = {
  GET_PROGRESS: "host/flag/progress",
};
